import AppRoutes from "./routes";

export default function App() {
    return <div class="h-full bg-gray-100 dark:bg-gray-900">
    <AppRoutes />
  </div>
}
